module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAABa0lEQVRIie2WzytEURTHP+81mqUMSlla2PAf8FdYyoaFlSjKTslCNkiRJFb+EnbKAoVINhPlV5ZijO50zjRe7907Ze67C741vZrTO5/zPfe98w6hFJW2rg06AuaBWaAro5YlYMFS5wYwZYk/AqvAClAtyJ8zwLLDfI8j3uuIdwvjHVhTxzdAH3AgVX0lbqoAF8CnJXER6AfilFgs5saAW8NSx9rePeDEUXmWjJNTS3xfwJ2kVJd02kpVky0Ior8L1rOteGTpG1E7a32qF4EB4Ngj2OTeBc5pmFy5K9jDZVrd1sS4a7XKBnwmoy5PXQVt9WCoVn8AdzmDw4/MaWBbvqm+VBRGbUvRAfICdADDwJEn8BBwCLwCJXWs14Llxt9Kc8f8f49DgiOPrB+59cCfgHZgAnjLWG8vZdhkybXejjew6uBN2adH5ZemHWDSAjY7+UgTzg2rDl6Xiud0703RvSPhgyP+LOYMK5CAb0J0Qqfs6fTfAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/code.png
// module id = xDq9
// module chunks = 1